export default function SEO(){
    return(
        <div className='ml-0 lg:ml-[256px]'>
            <div className="text-center">SEO Manager</div>
        </div>
    )
}